// store/modules/station.js
import { getWeekDays, getLastFiveMonths } from '@/utils/dateHelpers';
import { axios } from '@/network/request';

export default {
  namespaced: true,
  state() {
    return {
      towns: {
        "孙桥镇": [
          { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 },
          { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 },
          { id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 },
          { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }, { id: 20 },
          { id: 21 }, { id: 22 }, { id: 23 }
        ],
        "石龙镇": [
          { id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 },
          { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 },
          { id: 11 }, { id: 12 }, { id: 13 }, { id: 14 }, { id: 15 },
          { id: 16 }, { id: 17 }, { id: 18 }, { id: 19 }, { id: 20 },
          { id: 21 }
        ]
      },
      selectedTown: "孙桥镇", 
      selectedStationId: 1,
      selectedStation: null,
      loadingStationId: null,
      errorMessage: ''
    };
  },
  mutations: {
    setSelectedStationId(state, id) {
      state.selectedStationId = id;
    },
    setSelectedStation(state, station) {
      state.selectedStation = station;
    },
    setLoadingStationId(state, id) {
      state.loadingStationId = id;
    },
    setErrorMessage(state, message) {
      state.errorMessage = message;
    }
  },
  actions: {
    async fetchData({ commit }, originalStationId) {
      commit('setLoadingStationId', originalStationId);
      commit('setErrorMessage', '');

      // 根据奇偶性确定使用哪个测试站点的数据
      let apiStationId;
      if (originalStationId % 2 !== 0) {
        apiStationId = 0; // 奇数使用1号站点数据
      } else {
        apiStationId = 1; // 偶数使用2号站点数据
      }

      try {
        const response = await axios.get('/soil/week/formatted', {
          params: {
            uid: apiStationId 
          }
        });
        
        const weekDays = getWeekDays();
        const lastFiveMonths = getLastFiveMonths();
        const now = new Date();
        
        // 根据原始站点ID设置调整系数
        const getAdjustmentFactor = (id) => {
          const factors = {
            '1': 1.05,
            '2': 1.10,
            '3': 1.08,
            '4': 1.13,
            '5': 0.95,
            '6': 1.06,
            '7': 0.92,
            '8': 1.08,
            '9': 0.87,
            '10': 1.12,
            '11': 0.89,
            '12': 1.15,
            '13': 0.85,
            '14': 1.14,
            '15': 0.91,
            '16': 1.07,
            '17': 0.96,
            '18': 1.09,
            '19': 0.88,
            '20': 1.15,
            '21': 0.86,
            '22': 1.11,
            '23': 0.93
          };
          return factors[id.toString()] || 1; // 默认不调整
        };

        const adjustmentFactor = getAdjustmentFactor(originalStationId);
        
        // 数据调整函数
        const adjustValue = (value) => {
          if (value === null || value === undefined) return value;
          return Number((value * adjustmentFactor).toFixed(2)); // 保留2位小数
        };

        // 处理数组数据的调整
        const adjustArray = (arr) => {
          if (!Array.isArray(arr)) return arr;
          return arr.map(adjustValue);
        };

        const formattedData = {
          id: originalStationId, // 使用原始站点ID
          data: {
            time: now.toLocaleString('zh-CN', {
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            }),
            weeklyHumidity: {
              days: weekDays,
              indoor: adjustArray(response.data.data.soilHumidity),
              outdoor: response.data.data.soilHumidity.map(humidity => {
                const outdoorValue = humidity * 1.1;
                return Math.min(adjustValue(outdoorValue), 250);
              })
            },
            monthlyHumidity: {
              months: lastFiveMonths,
              values: adjustArray(response.data.data.soilHumidity)
            },
            weeklyWaterLevel: {
              days: weekDays,
              values: adjustArray(response.data.data.waterLevel)
            },
            soilTemperature: adjustArray(response.data.data.soilTemperature),
            soilEc: adjustValue(response.data.data.soilEc),
            soilPh: adjustValue(response.data.data.soilPh),
            monthlyData: adjustArray(response.data.data.monthData)
          }
        };

        commit('setSelectedStation', formattedData);
        commit('setSelectedStationId', originalStationId);
        return formattedData;

      } catch (err) {
        commit('setErrorMessage', err.message || '获取数据失败，请重试');
        throw err;
      } finally {
        commit('setLoadingStationId', null);
      }
    },

    // 切换选中站点
    async switchStation({ dispatch, commit }, station) {
      await dispatch('fetchData', station.id);
    },
  },

  getters: {
    currentStation: (state) => state.selectedStation,
    response: (state) => state.selectedStation?.data || {},
    isLoading: (state) => !!state.loadingStationId,
    stationsList: (state, getters, rootState) => {
      const selectedTown = rootState.home.townName;
      return state.towns[selectedTown] || [];
    },
    error: (state) => state.errorMessage
  }
};